
export default function VisitorInfo() {
  const infoCards = [
    {
      title: 'Hours & Seasons',
      icon: 'ri-time-line',
      details: [
        'Summer (May-Sep): 6 AM - 9 PM',
        'Fall/Spring: 7 AM - 7 PM',
        'Winter (Nov-Mar): 8 AM - 5 PM',
        'Open 7 days a week',
      ],
    },
    {
      title: 'Admission Fees',
      icon: 'ri-ticket-line',
      details: [
        'Adults: $12 per day',
        'Children (5-12): $6 per day',
        'Seniors (65+): $8 per day',
        'Annual Pass: $150',
      ],
    },
    {
      title: 'Facilities',
      icon: 'ri-building-line',
      details: [
        'Restrooms & Showers',
        'Visitor Center & Gift Shop',
        'Parking (Free)',
        'Picnic Areas & Pavilions',
      ],
    },
    {
      title: 'Rules & Safety',
      icon: 'ri-shield-check-line',
      details: [
        'Life jackets required for children',
        'No motorized boats',
        'Pack out all trash',
        'Pets on leash only',
      ],
    },
  ];

  return (
    <section id="visitor-info" className="py-24 px-6 bg-gradient-to-b from-sky-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Visitor Information
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to know before your visit
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {infoCards.map((card, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 bg-sky-100 text-sky-600 rounded-lg flex items-center justify-center mb-4">
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4">{card.title}</h3>
              <ul className="space-y-2">
                {card.details.map((detail, idx) => (
                  <li key={idx} className="text-sm text-gray-600 flex items-start">
                    <i className="ri-check-line text-sky-600 mr-2 mt-0.5"></i>
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-lg p-8 shadow-md">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Getting Here</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-sky-600 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="font-medium text-gray-900">Address</p>
                  <p className="text-sm text-gray-600">1234 Lakeshore Drive, Mountain View, CO 80401</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-car-line text-sky-600 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="font-medium text-gray-900">By Car</p>
                  <p className="text-sm text-gray-600">Free parking available. Follow signs from Highway 25.</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-bus-line text-sky-600 text-xl mr-3 mt-1"></i>
                <div>
                  <p className="font-medium text-gray-900">Public Transit</p>
                  <p className="text-sm text-gray-600">Bus Route 42 stops at the main entrance every hour.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-8 shadow-md">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Weather & Best Times</h3>
            <div className="space-y-4">
              <div>
                <p className="font-medium text-gray-900 mb-2">Spring (Mar-May)</p>
                <p className="text-sm text-gray-600">Mild temperatures, blooming wildflowers, excellent bird watching.</p>
              </div>
              <div>
                <p className="font-medium text-gray-900 mb-2">Summer (Jun-Aug)</p>
                <p className="text-sm text-gray-600">Warm and sunny, perfect for swimming and water activities.</p>
              </div>
              <div>
                <p className="font-medium text-gray-900 mb-2">Fall (Sep-Nov)</p>
                <p className="text-sm text-gray-600">Stunning foliage, cooler weather, ideal for hiking and photography.</p>
              </div>
              <div>
                <p className="font-medium text-gray-900 mb-2">Winter (Dec-Feb)</p>
                <p className="text-sm text-gray-600">Peaceful atmosphere, ice fishing, winter wildlife viewing.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
